import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../components/header";
import "./AIHub.css";

export default function AIHub() {
  useSelector((state) => ({ ...state }));
  const navigate = useNavigate();

  const aiServices = [
    {
      id: "chatbot",
      name: "ChatBot",
      description:
        "Assistente virtual inteligente para conversas, geração de texto e imagens",
      features: [
        "Conversas naturais e contextuais",
        "Geração de texto criativo",
        "Criação de imagens com IA",
        "Ajuda com programação",
        "Respostas em múltiplos idiomas",
      ],
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
        </svg>
      ),
      gradient: "linear-gradient(135deg, #10a37f, #0d8c6d)",
      path: "/ai/chatbot",
    },
    {
      id: "advogado",
      name: "Advogado AI",
      description:
        "Assistência jurídica inteligente com análise de casos e legislação",
      features: [
        "Análise de casos práticos",
        "Referências à legislação atual",
        "Upload de documentos legais",
        "Suporte multi-jurisdição",
        "Conexão com advogados reais",
      ],
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
        </svg>
      ),
      gradient: "linear-gradient(135deg, #3b82f6, #2563eb)",
      path: "/ai/advogado",
      badge: "Advogados Reais Disponíveis",
    },
    {
      id: "jornalista",
      name: "Jornalista AI",
      description:
        "Redação profissional de notícias de imprensa e artigos jornalísticos",
      features: [
        "10 sugestões de títulos",
        "Estrutura pirâmide invertida",
        "Lead profissional (5W+1H)",
        "Parágrafos personalizáveis",
        "Estilo editorial adaptável",
      ],
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
        </svg>
      ),
      gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
      path: "/ai/jornalista",
    },
  ];

  return (
    <div className="ai_hub_page">
      <Header page="ai" />
      <div className="ai_hub_container">
        <div className="ai_hub_header">
          <h1>Socializa AI</h1>
          <p>Escolha um assistente de IA para começar</p>
        </div>

        <div className="ai_services_grid">
          {aiServices.map((service) => (
            <div
              key={service.id}
              className="ai_service_card"
              onClick={() => navigate(service.path)}
            >
              <div
                className="ai_service_icon"
                style={{ background: service.gradient }}
              >
                {service.icon}
              </div>

              {service.badge && (
                <span className="ai_service_badge">{service.badge}</span>
              )}

              <h2>{service.name}</h2>
              <p className="ai_service_description">{service.description}</p>

              <ul className="ai_service_features">
                {service.features.map((feature, index) => (
                  <li key={index}>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <button className="ai_service_btn">
                Começar Conversa
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                </svg>
              </button>
            </div>
          ))}
        </div>

        <div className="ai_hub_info">
          <h3>Sobre a Socializa AI</h3>
          <p>
            Nossa plataforma utiliza tecnologia de inteligência artificial
            avançada para oferecer assistência personalizada em diferentes áreas.
            Todos os nossos assistentes são projetados para fornecer respostas
            precisas e úteis, mantendo sempre a privacidade e segurança dos seus
            dados.
          </p>

          <div className="ai_stats">
            <div className="ai_stat">
              <span className="ai_stat_number">24/7</span>
              <span className="ai_stat_label">Disponibilidade</span>
            </div>
            <div className="ai_stat">
              <span className="ai_stat_number">100%</span>
              <span className="ai_stat_label">Privacidade</span>
            </div>
            <div className="ai_stat">
              <span className="ai_stat_number">3</span>
              <span className="ai_stat_label">Assistentes</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
